/* XPOWER: lupa y zoom en las fotos del producto */
(function(){
  var LUPA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';
  var ZOOM = 2.2;

  function limita(v,a,b){ return Math.max(a, Math.min(b, v)); }

  function alta(img){
    var u = img.currentSrc || img.src || '';
    if(!u) return '';
    if(u.indexOf('/cdn/') === -1 && u.indexOf('cdn.shopify') === -1) return u;
    return u.split('?')[0] + '?width=1800';
  }

  /* La galeria mueve las fotos con transform, asi que todas siguen en el DOM.
     La que se esta viendo es la que tiene su centro mas cerca del centro del marco. */
  function fotoActiva(caja){
    var rc = caja.getBoundingClientRect();
    var cx = rc.left + rc.width/2, cy = rc.top + rc.height/2;
    var imgs = caja.querySelectorAll('img');
    var mejor = null, corta = Infinity;
    for(var i=0;i<imgs.length;i++){
      var r = imgs[i].getBoundingClientRect();
      if(r.width < 60 || r.height < 60) continue;
      var d = Math.abs((r.left + r.width/2) - cx) + Math.abs((r.top + r.height/2) - cy);
      if(d < corta){ corta = d; mejor = imgs[i]; }
    }
    return mejor;
  }

  function arma(){
    var caja = document.querySelector('.xp-gal__main') || document.querySelector('.xp-pdp .xp-gal');
    if(!caja || caja.dataset.xpZoom) return;
    caja.dataset.xpZoom = '1';
    caja.classList.add('xp-zoomable');

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'xp-lupa';
    boton.setAttribute('aria-label', 'Ampliar la foto');
    boton.innerHTML = LUPA + '<span>Ampliar</span>';
    caja.appendChild(boton);

    var lente = document.createElement('div');
    lente.className = 'xp-lente';
    caja.appendChild(lente);

    function tamanoLente(){
      var t = parseInt(getComputedStyle(lente).width, 10);
      return (t && t > 20) ? t : 150;
    }

    var fina = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    var puesta = '';

    if(fina){
      caja.addEventListener('mouseenter', function(){
        var img = fotoActiva(caja);
        if(!img) return;
        lente.classList.add('is-on');
      });
      caja.addEventListener('mouseleave', function(){ lente.classList.remove('is-on'); });

      caja.addEventListener('mousemove', function(e){
        var img = fotoActiva(caja);
        if(!img) return;
        var rc = caja.getBoundingClientRect();
        var ri = img.getBoundingClientRect();
        var L  = tamanoLente();
        var u  = alta(img);

        if(u !== puesta){
          puesta = u;
          lente.style.backgroundImage = 'url("' + u + '")';
        }
        var bw = ri.width * ZOOM, bh = ri.height * ZOOM;
        lente.style.backgroundSize = Math.round(bw) + 'px ' + Math.round(bh) + 'px';

        /* la lupa nunca se sale de la foto que se esta viendo */
        var lx = limita(e.clientX, ri.left + L/2, ri.right - L/2);
        var ly = limita(e.clientY, ri.top  + L/2, ri.bottom - L/2);
        lente.style.left = (lx - rc.left) + 'px';
        lente.style.top  = (ly - rc.top)  + 'px';

        var px = limita((e.clientX - ri.left) / ri.width, 0, 1);
        var py = limita((e.clientY - ri.top)  / ri.height, 0, 1);
        var bx = limita(-(px*bw - L/2), -(bw - L), 0);
        var by = limita(-(py*bh - L/2), -(bh - L), 0);
        lente.style.backgroundPosition = bx.toFixed(1) + 'px ' + by.toFixed(1) + 'px';
      });
    }

    var lbox = document.createElement('div');
    lbox.className = 'xp-lbox';
    lbox.innerHTML = '<button type="button" class="xp-lbox__x" aria-label="Cerrar">&times;</button><img class="xp-lbox__img" alt=""><div class="xp-lbox__hint">Pellizca para acercar · doble toque para ampliar</div>';
    document.body.appendChild(lbox);
    var grande = lbox.querySelector('.xp-lbox__img');
    var pista  = lbox.querySelector('.xp-lbox__hint');

    var e1 = 1, x1 = 0, y1 = 0;
    function pinta(){ grande.style.transform = 'translate(-50%,-50%) translate(' + x1 + 'px,' + y1 + 'px) scale(' + e1 + ')'; }

    function abre(){
      var img = fotoActiva(caja);
      if(!img) return;
      grande.src = alta(img);
      e1 = 1; x1 = 0; y1 = 0; pinta();
      lbox.classList.add('is-on');
      document.body.classList.add('xp-lbox-open');
      pista.classList.remove('is-off');
      setTimeout(function(){ pista.classList.add('is-off'); }, 2600);
      lente.classList.remove('is-on');
    }
    function cierra(){
      lbox.classList.remove('is-on');
      document.body.classList.remove('xp-lbox-open');
    }

    boton.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); abre(); });
    lbox.querySelector('.xp-lbox__x').addEventListener('click', cierra);
    lbox.addEventListener('click', function(e){ if(e.target === lbox) cierra(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') cierra(); });

    var px0 = 0, py0 = 0;
    caja.addEventListener('pointerdown', function(e){ px0 = e.clientX; py0 = e.clientY; });
    caja.addEventListener('click', function(e){
      if(Math.abs(e.clientX - px0) > 12 || Math.abs(e.clientY - py0) > 12) return;
      if(e.target.closest('a')) return;
      abre();
    });

    var ultimo = 0;
    grande.addEventListener('click', function(){
      var ahora = Date.now();
      if(ahora - ultimo < 320){
        e1 = (e1 > 1.2) ? 1 : 2.6;
        if(e1 === 1){ x1 = 0; y1 = 0; }
        pinta();
      }
      ultimo = ahora;
    });

    var dedos = {}, dist0 = 0, esc0 = 1, arrX = 0, arrY = 0, ax0 = 0, ay0 = 0;
    lbox.addEventListener('pointerdown', function(e){
      dedos[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(dedos);
      if(ids.length === 1){ arrX = e.clientX; arrY = e.clientY; ax0 = x1; ay0 = y1; }
      if(ids.length === 2){
        var a = dedos[ids[0]], b = dedos[ids[1]];
        dist0 = Math.hypot(a.x-b.x, a.y-b.y);
        esc0 = e1;
      }
    });
    lbox.addEventListener('pointermove', function(e){
      if(!dedos[e.pointerId]) return;
      dedos[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(dedos);
      if(ids.length >= 2){
        var a = dedos[ids[0]], b = dedos[ids[1]];
        var d = Math.hypot(a.x-b.x, a.y-b.y);
        if(dist0 > 0){
          e1 = limita(esc0 * (d / dist0), 1, 5);
          if(e1 === 1){ x1 = 0; y1 = 0; }
          pinta();
        }
      } else if(e1 > 1.02){
        x1 = ax0 + (e.clientX - arrX);
        y1 = ay0 + (e.clientY - arrY);
        pinta();
      }
    });
    function suelta(e){ delete dedos[e.pointerId]; dist0 = 0; }
    lbox.addEventListener('pointerup', suelta);
    lbox.addEventListener('pointercancel', suelta);

    lbox.addEventListener('wheel', function(e){
      e.preventDefault();
      e1 = limita(e1 + (e.deltaY < 0 ? 0.22 : -0.22), 1, 5);
      if(e1 === 1){ x1 = 0; y1 = 0; }
      pinta();
    }, { passive: false });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', arma); } else { arma(); }
  setTimeout(arma, 900);
})();